export default {"src":"/_next/static/media/bundle-float-1.668b794b.svg","height":30,"width":36,"blurWidth":0,"blurHeight":0};